import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { wagmiConfig } from './config/wagmi';
import { ThemeProvider } from './contexts/ThemeContext';
import App from './App';
import { AppProvider } from './contexts/AppProvider';
import '@rainbow-me/rainbowkit/styles.css';
import './assets/fonts/fonts.css';

// Handle MetaMask provider conflicts
const handleProviderConflicts = () => {
  if (typeof window !== 'undefined') {
    const originalConsoleError = console.error;
    console.error = (...args) => {
      const message = args[0];
      if (typeof message === 'string' &&
          (message.includes('MetaMask encountered an error setting the global Ethereum provider') ||
           message.includes('Cannot set property ethereum'))) {
        return;
      }
      originalConsoleError.apply(console, args);
    };
  }
};

handleProviderConflicts();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>
          <ThemeProvider>
            <BrowserRouter>
              <AppProvider>
                <App />
              </AppProvider>
            </BrowserRouter>
          </ThemeProvider>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);
